import { useEffect, useRef, useState } from 'react';
import { CarTaxiFront, ShoppingCart } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { ArrowHeadSvg, CrossSvg, HamburgerSvg, PersonSvg } from '../../assets/svg';
import Logo from '../../assets/images/logo/logo.png';
import LogoCircle from '../../assets/images/logo/logo-circle.png';
import { useAuth } from '../../contexts/AuthContext';
import { useCommonContext } from '../../contexts/CommonContext';
import * as AuthActions from '../../redux/actions/authAction';
import * as CommonActions from '../../redux/actions/commonAction';
import * as EcommerceActions from '../../redux/actions/ecommerceAction';
import ComingSoonModal from './ComingSoonModal';
import LanguageSelector from './LanguageSelector';

const Header = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { sidebarWidth } = useCommonContext();
    const { customerDetails } = useSelector(state => state?.authReducer);
    // console.log("Customer Details :::", customerDetails);

    const { isScreenScroll } = useSelector(state => state?.commonReducer);
    const { productCartData } = useSelector(state => state?.ecommerceReducer);
    const isDashboardRoute = location.pathname.startsWith("/dashboard") || location.pathname.startsWith("/verification") || location.pathname.startsWith("/profile/edit");

    const navRef = useRef(null);
    const [shownav, setShownav] = useState(false);
    const [showComingSoon, setShowComingSoon] = useState(false);

    //* Handle Resize and Scroll Event Listener 
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 500) {
                setShownav(false)
            }
        };

        const handleScroll = () => {
            if (window.scrollY > 20) {
                dispatch(CommonActions.setScreenScroll(true));
            } else {
                dispatch(CommonActions.setScreenScroll(false));
            }
        }

        const handleClickOutside = (event) => {
            if (navRef.current && !navRef.current.contains(event.target)) {
                setShownav(false);
            }
        };

        window.addEventListener('resize', handleResize);
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('scroll', handleScroll);

        if (shownav) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            window.removeEventListener('resize', handleResize);
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('scroll', handleScroll);
        };
    }, [shownav, isScreenScroll]);

    useEffect(() => {
        customerDetails && dispatch(EcommerceActions?.getProductCart());
    }, [customerDetails]);

    return (
        <>
            <ComingSoonModal isOpen={showComingSoon} onClose={() => setShowComingSoon(false)} />
            <header className={`fixed w-full z-[1000] top-0 px-4 py-3 bg-white shadow-md`}>
                <main className='flex items-center justify-between'>
                    <Link to={'/'}><img src={Logo} className='h-10 lg:h-12' /></Link>

                    <nav className='max-md:hidden flex max-md:flex-wrap items-center gap-1 text-[15px] font-medium'>
                        <NavLink to={'/'} className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "bg-primary text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out" : "hover:bg-primary hover:text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out"}>Home</NavLink>
                        {/* <NavLink to={'/flights-booking'} className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "bg-primary text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out" : "hover:bg-primary hover:text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out"}>Flights</NavLink> */}
                        <button onClick={() => setShowComingSoon(true)} className="hover:bg-primary hover:text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out">Recharge</button>
                        <NavLink to={'/milan-sathi'} className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "bg-primary text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out" : "hover:bg-primary hover:text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out"}>Milan Sathi</NavLink>
                        <NavLink to={'/puja'} className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "bg-primary text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out" : "hover:bg-primary hover:text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out"}>Book a Puja</NavLink>
                        <NavLink to={'/marketplace'} className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "bg-primary text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out" : "hover:bg-primary hover:text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out"}>Marketplace</NavLink>
                        <NavLink to={'/new-yatra'} className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "bg-primary text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out" : "hover:bg-primary hover:text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out"}>Yatra</NavLink>
                    </nav>

                    <div className='flex gap-5 max-lg:hidden items-center'>
                        <LanguageSelector compact />
                        {!customerDetails &&
                            <div
                                onClick={() => dispatch(AuthActions.toggleLoginModal(true))}
                                className='bg-gradient-to-r from-[#4EADFD] to-primary text-xs px-2 py-1 lg:py-1.5 flex items-center justify-between gap-3 rounded-md text-white cursor-pointer'>
                                <div className='flex items-center gap-1'>
                                    <div><img src={LogoCircle} className='h-7 w-7' /></div>
                                    <div>Login or Create Account</div>
                                </div>
                                <div className='inline-block rotate-90'><ArrowHeadSvg h={20} w={20} /></div>
                            </div>
                        }

                        {customerDetails && Object.keys(customerDetails).length > 0 && <>
                            <Link to={`/marketplace/cart`} className='flex items-center gap-1 cursor-pointer text-secondary font-semibold'>
                                <div className='flex relative'>
                                    <ShoppingCart />
                                    <p className='absolute -right-1 -top-3'>{productCartData?.data?.length || 0}</p>
                                </div>
                            </Link>
                        </>}

                        {customerDetails && Object.keys(customerDetails).length > 0 &&
                            <div className='group relative text-black max-lg:hidden'>
                                <div className='flex items-center gap-1 cursor-pointer text-secondary font-semibold'><PersonSvg /> <div>{customerDetails?.firstname || customerDetails?.mobile}</div></div>

                                <div className='font-normal absolute overflow-hidden top-[50px] custom-scrollbar-zero right-0 bg-white w-56 h-0 rounded-lg group-hover:h-[360px] max-h-[360px] overflow-y-scroll transition-all duration-500 ease-in group-hover:border-b-[5px] group-hover:border-t border-primary shadow-2xl'>
                                    <div className='flex flex-col items-center gap-1.5 py-5'>
                                        <div className='text-[16px]'>{customerDetails?.firstname || customerDetails?.mobile}</div>
                                        <div className='text-sm'>XXXXXX{customerDetails?.mobile?.toString()?.substring(6, 10)}</div>
                                    </div>
                                    <div onClick={() => navigate('/profile')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><div>My Profile</div></div>
                                    <div onClick={() => navigate('/marketplace/cart')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><div>My Cart</div></div>
                                    <div onClick={() => navigate('/history/recharge-history')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><p>Recharge History</p></div>
                                    <div onClick={() => navigate('/history/product-history')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><p>Product History</p></div>
                                    <div onClick={() => navigate('/history/puja-history')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><p>Puja History</p></div>
                                    <div onClick={() => navigate('/history/yatra-history')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><p>Yatra History</p></div>
                                    <div onClick={() => navigate('/history/newyatra-history')} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><p>Yatra Bookings</p></div>
                                    <div onClick={() => dispatch(AuthActions.customerLogout({ onComplete: () => navigate('/') }))} className='flex items-center gap-3 border-t py-2 px-5 cursor-pointer hover:text-primary'><div>Logout</div></div>
                                </div>
                            </div>
                        }
                    </div>

                    <div onClick={() => setShownav(!shownav)} className={`cursor-pointer lg:hidden ${shownav == true && 'invisible'}`}><HamburgerSvg h={'30'} w={'30'} /></div>
                </main>

                <main ref={navRef} className={`pb-40 flex flex-col gap-5 p-5 absolute h-full bg-white text-black_primary border-r border-primary shadow-lg top-0 z-50 min-h-[100vh] w-[80vw] transition-all duration-500 overflow-y-scroll ${shownav ? 'left-0' : 'left-[-200vw]'}`}>

                    <div onClick={() => setShownav(!shownav)} className='flex items-center justify-center gap-2 text-sm font-semibold cursor-pointer'>CLOSE <CrossSvg w={'20'} /></div>
                    <div className='text-center font-semibold text-sm'>WHAT ARE YOU LOOKING FOR?</div>

                    <div className='flex flex-col'>
                        {!customerDetails &&
                            <div onClick={() => {
                                dispatch(AuthActions.toggleLoginModal(true))
                                setShownav(!shownav)
                            }} to="/auth/login" className='text-black border-b py-4 hover:text-primary cursor-pointer'><div className='flex items-center gap-2'>Login/Signup</div></div>
                        }

                        {customerDetails && Object.keys(customerDetails).length > 0 &&
                            <>
                                <NavLink onClick={() => setShownav(!shownav)} to="/dashboard" className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "text-primary border-b py-4 hover:text-primary" : "text-black  border-b py-4 hover:text-primary"}>Profile</NavLink>
                            </>
                        }

                        <button onClick={() => { setShownav(false); setShowComingSoon(true); }} className='text-black border-b py-4 hover:text-primary text-left w-full'><div className='flex items-center gap-2'>Recharge</div></button>
                        <NavLink onClick={() => setShownav(!shownav)} to="/milan-sathi" className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "text-primary border-b py-4 hover:text-primary" : "text-black  border-b py-4 hover:text-primary"}><div className='flex items-center gap-2'>Milan Sathi</div></NavLink>
                        <NavLink onClick={() => setShownav(!shownav)} to="/puja" className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "text-primary border-b py-4 hover:text-primary" : "text-black  border-b py-4 hover:text-primary"}><div className='flex items-center gap-2'>Book a Puja</div></NavLink>
                        <NavLink onClick={() => setShownav(!shownav)} to="/marketplace" className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "text-primary border-b py-4 hover:text-primary" : "text-black  border-b py-4 hover:text-primary"}><div className='flex items-center gap-2'>Marketplace</div></NavLink>
                        <NavLink onClick={() => setShownav(!shownav)} to="/new-yatra" className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "text-primary border-b py-4 hover:text-primary" : "text-black  border-b py-4 hover:text-primary"}><div className='flex items-center gap-2'>Yatra</div></NavLink>

                        {customerDetails && Object.keys(customerDetails).length > 0 &&
                            <>
                                <NavLink onClick={() => setShownav(!shownav)} to="/marketplace/cart" className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "text-primary border-b py-4 hover:text-primary" : "text-black  border-b py-4 hover:text-primary"}>My Cart</NavLink>

                                <div onClick={() => dispatch(AuthActions.customerLogout({ onComplete: () => navigate('/') }))} className='cursor-pointer text-black border-b py-4 hover:text-primary'>Logout</div>
                            </>
                        }
                    </div>
                </main>
            </header>
        </>
    )
}

export default Header;